import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── Global error recovery ────────────────────────────────────────────────

// 1. ChunkLoadError: new deployment invalidated old chunk hashes.
//    Reload once so the browser fetches fresh index.html + new chunks.
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Loading CSS chunk')
  ) {
    const reloadKey = 'chunk_reload_attempted';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1');
      window.location.reload();
    }
  }
});

// 2. Symbol.toStringTag TypeError: Lodash's getRawTag() tries to temporarily
//    write to Symbol.toStringTag of native objects (DataView, etc.) inside a
//    try/catch. In some runtime environments the try block is not sufficient.
//    This is non-fatal — suppress it so it does not surface as an unhandled error.
window.addEventListener('error', (event) => {
  if (
    event.message?.includes("Symbol(Symbol.toStringTag)") ||
    event.message?.includes("read only property 'Symbol")
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
